(function () {
  'use strict';

  /* ---------- Close <details> dropdowns when clicking outside ---------- */
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details[data-close-outside][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[data-close-outside][open]').forEach(function (d) {
      d.removeAttribute('open');
      var s = d.querySelector('summary'); if (s) s.focus();
    });
  });

  /* ---------- Mobile menu ---------- */
  var toggle = document.querySelector('[data-menu-toggle]');
  var panel = document.getElementById('MobileMenu');
  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
    var current = 0;
    function show(i) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === current); });
      thumbs.forEach(function (t, n) {
        t.classList.toggle('is-active', n === current);
        t.setAttribute('aria-current', n === current ? 'true' : 'false');
      });
    }
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (prev) prev.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });

    // Swipe on touch devices
    var startX = null;
    root.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      startX = null;
    });

    return {
      showMedia: function (mediaId) {
        slides.forEach(function (s, n) { if (String(s.dataset.mediaId) === String(mediaId)) show(n); });
      }
    };
  }

  /* ---------- Variant picker ---------- */
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; });
  }
  var checkIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="m4 12.5 5 5L20 6.5"/></svg>';

  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var galleryEl = section.querySelector('[data-gallery]');
    var gallery = galleryEl ? initGallery(galleryEl) : null;
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var data;
    try { data = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var form = section.querySelector('[data-product-form]');
    var idInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price-value]');
    var stockEl = section.querySelector('[data-stock]');
    var addBtn = section.querySelector('[data-add-button]');
    var radios = Array.prototype.slice.call(section.querySelectorAll('input[data-option-index]'));

    function selectedOptions() {
      var opts = [];
      radios.forEach(function (r) { if (r.checked) opts[Number(r.dataset.optionIndex)] = r.value; });
      return opts;
    }
    function findVariant(opts) {
      return data.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function markUnavailable() {
      var opts = selectedOptions();
      radios.forEach(function (r) {
        var idx = Number(r.dataset.optionIndex);
        var test = opts.slice(); test[idx] = r.value;
        var v = findVariant(test);
        r.classList.toggle('is-unavailable', !v || !v.available);
      });
    }

    function update() {
      var v = findVariant(selectedOptions());
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = data.labels.unavailable; }
        return;
      }
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price_formatted;
      if (stockEl) {
        if (!v.available) {
          stockEl.innerHTML = escapeHtml(data.labels.out_of_stock);
          stockEl.classList.add('stock--out');
        } else {
          var label = (v.tracked && v.qty > 0) ? data.labels.in_stock_count.replace('__COUNT__', v.qty) : data.labels.in_stock;
          stockEl.innerHTML = checkIcon + escapeHtml(label);
          stockEl.classList.remove('stock--out');
        }
      }
      if (addBtn && !data.limit_reached) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? data.labels.add : data.labels.sold_out;
      }
      if (gallery && v.media_id) gallery.showMedia(v.media_id);
      markUnavailable();
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState({}, '', url.toString());
      }
    }

    radios.forEach(function (r) { r.addEventListener('change', update); });
    var officeSelect = section.querySelector('[data-office-select]');
    if (officeSelect) officeSelect.addEventListener('change', function () {
      officeSelect.classList.remove('is-invalid');
      var err = section.querySelector('[data-form-error]'); if (err) err.textContent = '';
    });
    if (radios.length) markUnavailable();

    if (form) {
      var errorEl = section.querySelector('[data-form-error]');
      form.addEventListener('submit', function (e) {
        if (form.dataset.officeCheckout === 'true') {
          // Office mode: go straight to checkout with the office as shipping address (1 item only).
          e.preventDefault();
          var select = section.querySelector('[data-office-select]');
          var opt = select && select.options[select.selectedIndex];
          if (!opt || !opt.value) {
            if (select) { select.classList.add('is-invalid'); select.focus(); }
            if (errorEl) errorEl.textContent = data.labels.office_required;
            return;
          }
          if (select) select.classList.remove('is-invalid');
          if (errorEl) errorEl.textContent = '';
          var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          var params = new URLSearchParams();
          params.set('checkout[shipping_address][address1]', opt.dataset.address1 || '');
          params.set('checkout[shipping_address][address2]', opt.dataset.name || '');
          params.set('checkout[shipping_address][zip]', opt.dataset.zip || '');
          params.set('checkout[shipping_address][city]', opt.dataset.city || '');
          if (opt.dataset.country) params.set('checkout[shipping_address][country]', opt.dataset.country);
          if (addBtn) addBtn.disabled = true;
          window.location.href = rootUrl + 'cart/' + encodeURIComponent(idInput.value) + ':1?' + params.toString();
          return;
        }
        if (form.dataset.singleItem !== 'true') {
          if (addBtn) addBtn.setAttribute('aria-disabled', 'true');
          return;
        }
        // Single-item mode: empty the cart first, then add exactly 1 of the chosen variant.
        e.preventDefault();
        if (addBtn) addBtn.disabled = true;
        if (errorEl) errorEl.textContent = '';
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var json = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
        // Shopify returns a JSON error (message + description) when it refuses a request.
        function readError(r) {
          return r.json().catch(function () { return {}; }).then(function (body) {
            var err = new Error(body.description || body.message || ('HTTP ' + r.status));
            err.shopify = true;
            throw err;
          });
        }
        fetch(root + 'cart/clear.js', { method: 'POST', headers: json, body: '{}' })
          .then(function (r) { if (!r.ok) return readError(r); })
          .then(function () {
            return fetch(root + 'cart/add.js', {
              method: 'POST', headers: json,
              body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
            });
          })
          .then(function (r) { if (!r.ok) return readError(r); })
          .then(function () {
            window.location.href = form.dataset.redirect === 'checkout' ? root + 'checkout' : root + 'cart';
          })
          .catch(function (err) {
            if (addBtn) addBtn.disabled = false;
            if (err && err.shopify) {
              // Show Shopify's own reason so the problem can be identified.
              if (errorEl) errorEl.textContent = data.labels.error + ' (' + err.message + ')';
            } else {
              // Network/script problem: fall back to a normal form submit.
              form.dataset.singleItem = 'false';
              form.submit();
            }
          });
      });
    }
  });

  /* ---------- Cart: choose delivery office, then open checkout with that address ---------- */
  document.querySelectorAll('form[data-office-cart]').forEach(function (cartForm) {
    var select = cartForm.querySelector('[data-office-select]');
    var errorEl = cartForm.querySelector('[data-office-error]');
    if (!select) return;
    select.addEventListener('change', function () {
      select.classList.remove('is-invalid');
      if (errorEl) errorEl.textContent = '';
    });
    cartForm.querySelectorAll('[data-checkout-field]').forEach(function (input) {
      input.addEventListener('input', function () {
        input.classList.remove('is-invalid');
        if (errorEl) errorEl.textContent = '';
      });
    });
    cartForm.addEventListener('submit', function (e) {
      var submitter = e.submitter;
      if (submitter && submitter.name && submitter.name !== 'checkout') return; // e.g. "Update"
      e.preventDefault();
      var opt = select.options[select.selectedIndex];
      if (!opt || !opt.value) {
        select.classList.add('is-invalid');
        select.focus();
        if (errorEl) errorEl.textContent = errorEl.dataset.message || '';
        return;
      }
      // Optional personal details, passed on to checkout
      var fields = {};
      var firstEmpty = null;
      cartForm.querySelectorAll('[data-checkout-field]').forEach(function (input) {
        var v = input.value.trim();
        fields[input.dataset.checkoutField] = v;
        var bad = input.hasAttribute('data-required') && !v;
        input.classList.toggle('is-invalid', bad);
        if (bad && !firstEmpty) firstEmpty = input;
      });
      if (firstEmpty) {
        firstEmpty.focus();
        if (errorEl) errorEl.textContent = errorEl.dataset.messageFields || '';
        return;
      }
      if (fields.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email)) {
        var emailInput = cartForm.querySelector('[data-checkout-field="email"]');
        if (emailInput) { emailInput.classList.add('is-invalid'); emailInput.focus(); }
        if (errorEl) errorEl.textContent = errorEl.dataset.messageEmail || '';
        return;
      }
      if (errorEl) errorEl.textContent = '';
      var lines = cartForm.dataset.cartLines;
      if (!lines) return;
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var params = new URLSearchParams();
      params.set('checkout[shipping_address][address1]', opt.dataset.address1 || '');
      params.set('checkout[shipping_address][address2]', opt.dataset.name || '');
      params.set('checkout[shipping_address][zip]', opt.dataset.zip || '');
      params.set('checkout[shipping_address][city]', opt.dataset.city || '');
      if (opt.dataset.country) params.set('checkout[shipping_address][country]', opt.dataset.country);
      if (fields.first_name) params.set('checkout[shipping_address][first_name]', fields.first_name);
      if (fields.last_name) params.set('checkout[shipping_address][last_name]', fields.last_name);
      if (fields.email) params.set('checkout[email]', fields.email);
      if (fields.discount) params.set('discount', fields.discount.replace(/,/g, ''));
      if (submitter) submitter.disabled = true;
      window.location.href = rootUrl + 'cart/' + lines + '?' + params.toString();
    });
  });

  /* ---------- Favorites (stored in this browser only) ---------- */
  var FAV_KEY = 'k75:favorites';
  function readFavs() { try { return JSON.parse(localStorage.getItem(FAV_KEY)) || []; } catch (e) { return []; } }
  function writeFavs(list) { try { localStorage.setItem(FAV_KEY, JSON.stringify(list)); } catch (e) { /* ignore */ } }
  document.querySelectorAll('[data-wishlist]').forEach(function (btn) {
    var handle = btn.dataset.wishlist;
    function render() {
      var on = readFavs().indexOf(handle) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    btn.addEventListener('click', function () {
      var list = readFavs();
      var i = list.indexOf(handle);
      if (i === -1) list.push(handle); else list.splice(i, 1);
      writeFavs(list); render();
    });
    render();
  });
})();
